
/** action types */
const rts = {
  handleSet_demoMode: 'handleSet_demoMode',
  handleClear_demoMode: 'handleClear_demoMode',
};

/** initial state */
export const regDataInitialState = (initState) => {
  return { ...initState }
};

/** reducer */
export const regDataReducer = (state, action) => {
  const { type, value } = action;

  switch (type) {
    case rts.handleSet_demoMode:
      const { rds } = action
      const { regInfo } = rds
      return { ...state, isRegDemo: true, regInfo };

    case rts.handleClear_demoMode:
      return { ...state, isRegDemo: false, regInfo: null };

    default:
      return state;
  }
};

export const regDataHandlers = (dispatch) => {
  return {
    handleSet_demoMode: (rds) => { dispatch({ type: rts.handleSet_demoMode, dispatch, rds }) },
    handleClear_demoMode: () => { dispatch({ type: rts.handleClear_demoMode, dispatch }) },
  }
}
